export default __webpack_public_path__ + "static/media/372.fe0c767a.jpg";